class ProductAddons extends HTMLElement {
  constructor() {
    super();
    this.productForm = document.querySelector(".main-product__form");
    this.cartDrawer = document.querySelector("cart-drawer");
    this.variantSelector = document.querySelector(
      'select[name="id"], input[name="id"]',
    );
    window.submissionId = this.generateUUID();
    this.isFormSubmitting = false;
  }

  connectedCallback() {
    if (this.variantSelector) {
      this.variantSelector.addEventListener(
        "change",
        this.handleVariantChange.bind(this),
      );
    }

    if (this.productForm) {
      this.productForm.addEventListener(
        "submit",
        this.handleFormSubmit.bind(this),
      );
    }
  }

  disconnectedCallback() {
    if (this.variantSelector) {
      this.variantSelector.removeEventListener(
        "change",
        this.handleVariantChange.bind(this),
      );
    }

    if (this.productForm) {
      this.productForm.removeEventListener(
        "submit",
        this.handleFormSubmit.bind(this),
      );
    }
  }

  generateUUID() {
    const newUUID = crypto.randomUUID();
    this.submissionId = newUUID;
    return newUUID;
  }

  async handleVariantChange() {
    const variantId = this.variantSelector.value;
    const sectionId = this.dataset.sectionId;

    try {
      const response = await fetch(
        `${window.location.pathname}?section_id=${sectionId}&variant=${variantId}`,
      );

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      // Find the new addons container
      const newAddonsContainer = doc.querySelector("[data-addon-container]");

      if (newAddonsContainer) {
        // Replace the current addons
        const currentAddonsContainer = this.querySelector(
          "[data-addon-container]",
        );
        if (currentAddonsContainer) {
          currentAddonsContainer.innerHTML = newAddonsContainer.innerHTML;
        }
      }

      // Update the variant ID
      this.dataset.variantId = variantId;
    } catch (error) {
      console.error("Error updating addons:", error);
    }
  }

  async handleFormSubmit(event) {
    if (this.isFormSubmitting) return; // Prevent multiple submissions
    this.isFormSubmitting = true;

    event.preventDefault();

    window.submissionId = this.generateUUID();
    this.productForm.dispatchEvent(new Event("submit", { bubbles: true }));

    setTimeout(() => {
      this.isFormSubmitting = false;
    }, 1000);
  }
}

customElements.define("product-addons", ProductAddons);
